module.exports = __webpack_public_path__ + "img/titile_bg_tzyd.ac2ee9dc.png";